import React from 'react';
import { styled, keyframes } from '@mui/material/styles';

interface CircularChartProps {
  projectName: string | undefined;
  hours: string;
  percentage: number;
  color: string | undefined;
  className?: string;
  width?: number;
  height?: number;
}

const CircularChartSVG = styled('svg')(({ theme }) => ({
  display: 'block',
  margin: theme.spacing(0),
}));

const CircleBoundary = styled('circle')(() => ({
  fill: 'none',
  stroke: '#D9D9D9',
  strokeWidth: 0.5,
}));

const CircleBackground = styled('path')(() => ({
  fill: 'none',
  stroke: '#FBFBFB',
  strokeWidth: 5.5,
}));

const progressAnimation = keyframes`
  0% {
    stroke-dasharray: 0 100;
  }
`;

const Circle = styled('path')(({ color }) => ({
  fill: 'none',
  stroke: color,
  strokeWidth: 5,
  animation: `${progressAnimation} 1s ease-out forwards`,
}));

const SvgTitleText = styled('text')(({ theme }) => ({
  fill: '#28364C',
  color: '#28364C',
  fontSize: '6px',
  fontWeight: theme.typography.fontWeightBold,
  textAnchor: 'middle',
}));

const SvgBodyText = styled('text')(({ theme }) => ({
  fill: '#8D8D8D',
  fontSize: '3.75px',
  fontWeight: theme.typography.fontWeightRegular,
  textAnchor: 'middle',
}));

const CircularChartIcon: React.FC<CircularChartProps> = function CircularChartIcon({
  projectName,
  hours,
  percentage,
  color,
  className,
  width,
  height,
}: CircularChartProps) {
  return (
    <CircularChartSVG
      viewBox="0 0 36 36"
      width={width}
      height={height}
      className={className}
    >
      <CircleBoundary
        r="17"
        cx="18"
        cy="16"
      />
      <CircleBoundary
        r="11"
        cx="18"
        cy="16"
      />
      <CircleBackground
        d="M18 2.0845
            a 14 14 0 0 1 0 28
            a 14 14 0 0 1 0 -28"
      />
      <Circle
        strokeDasharray={`${(percentage * 87.92) / 100} 100`}
        d="M18 2.0845
            a 14 14 0 0 1 0 28
            a 14 14 0 0 1 0 -28"
        color={color}
      />
      <SvgTitleText x="18" y="15">{projectName}</SvgTitleText>
      <SvgBodyText x="18" y="21.5">{hours}</SvgBodyText>
    </CircularChartSVG>
  );
};

CircularChartIcon.defaultProps = {
  className: '',
  width: 80,
  height: 90,
};

export default CircularChartIcon;
